import React from "react";
import { ProgramsTable } from "../../../../../components/program-library/ProgramsTableScreen";

export const CoachProgramLibraryList = () => {
  return <ProgramsTable />;
};

export const CoachProgramLibraryPublishedRoute = () => {
  return <CoachProgramLibraryList />;
};

